import React from 'react'
import { Reorder, useDragControls } from 'framer-motion'
import QueueItemCard from './QueueItemCard'

const SortableQueueItem = ({
  item,
  isDarkMode,
  handleRemoveFromQueue,
  timeLabel,
  queueActionsAvailable = true,
  isDragging = false,
  onDragStart,
  onDragEnd
}) => {
  const dragControls = useDragControls()
  const itemId = item.id.toString()
  const isItemDraggable = item.status !== 'playing' && queueActionsAvailable

  const handleDragHandlePointerDown = (event) => {
    if (!isItemDraggable) {
      return
    }

    onDragStart?.(itemId)
    dragControls.start(event)
  }

  return (
    <Reorder.Item
      value={itemId}
      drag={isItemDraggable ? 'y' : false}
      dragListener={false}
      dragControls={dragControls}
      whileDrag={isItemDraggable ? { scale: 1.01, zIndex: 60 } : undefined}
      transition={{ type: 'spring', stiffness: 520, damping: 40, mass: 0.6 }}
      onDragEnd={() => {
        if (isItemDraggable) {
          onDragEnd?.(itemId)
        }
      }}
      className="touch-pan-y"
    >
      <QueueItemCard
        item={item}
        isDarkMode={isDarkMode}
        handleRemoveFromQueue={handleRemoveFromQueue}
        timeLabel={timeLabel}
        onDragHandlePointerDown={handleDragHandlePointerDown}
        isDragging={isDragging}
        disableRemove={!queueActionsAvailable}
      />
    </Reorder.Item>
  )
}

export default SortableQueueItem
